import { action, Action, PayloadAction } from 'typesafe-actions';

import * as constants from './constants';
import { SessionTypeKeys } from './types';
import { MarketplaceProperties, UserObject, ExtendedSessionState } from './reducer';

export type SignedWebSocketUrlPayload = {
    signedWebSocketUrl: string;
}

export const setLanguage = (language: string): PayloadAction<string, string> => {
    return action(SessionTypeKeys.SET_LANGUAGE, language);
};

export const setUserInfo = (user: UserObject): PayloadAction<string, UserObject> => {
    return action(SessionTypeKeys.SET_USER_INFO, user);
};

export const setCsrfToken = (token: string): PayloadAction<string, string> => {
    return action(constants.SET_CSRF_TOKEN, token);
};

export const setMarketplaceProperties = (mpProps: MarketplaceProperties): PayloadAction<string, MarketplaceProperties> => {
    return action(SessionTypeKeys.SET_MARKETPLACE_PROPERTIES, mpProps);
};


export const fetchSignedWebSocketUrl = (): Action => action(constants.FETCH_SIGNED_WEBSOCKET_URL);

export const setSignedWebSocketUrl = (signedWebSocketUrl: string): PayloadAction<string, SignedWebSocketUrlPayload> => action(
    constants.SET_SIGNED_WEBSOCKET_URL, { signedWebSocketUrl }
);

export const logoutUser = (): Action => action(SessionTypeKeys.LOGOUT_USER);

export const setSessionData = (sessionData: ExtendedSessionState): PayloadAction<SessionTypeKeys.SET_SESSION_DATA, ExtendedSessionState> => {
    return action(SessionTypeKeys.SET_SESSION_DATA, sessionData);
};
